var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationBell2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Notification Bell"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#1b1c1d",
    strokeWidth: 1.5,
    "data-name": "Ellipse 27"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M20.05 17.91c-.4 0-.64-.2-.77-.7a9.04 9.04 0 0 1-.14-2 12.96 12.96 0 0 0-.24-2.94.2.2 0 0 0-.4.1 12.64 12.64 0 0 1 .22 2.85 9.26 9.26 0 0 0 .16 2.1 1.68 1.68 0 0 0 .28.6h-8.7a1.68 1.68 0 0 0 .27-.6 9.25 9.25 0 0 0 .16-2.1 9.03 9.03 0 0 1 .51-3.66c.56-1.2 1.68-1.77 3.4-1.77a4.45 4.45 0 0 1 2.32.53 2.8 2.8 0 0 1 1.13 1.32.2.2 0 0 0 .38-.17 3.25 3.25 0 0 0-1.3-1.51 3.96 3.96 0 0 0-1.28-.48 1.24 1.24 0 0 0-2.48 0 4 4 0 0 0-1.24.45 3.22 3.22 0 0 0-1.31 1.45 9.32 9.32 0 0 0-.55 3.83 9.03 9.03 0 0 1-.15 2c-.13.5-.36.7-.76.7a1.22 1.22 0 0 0 0 2.45h1.32a.2.2 0 1 0 0-.42H9.56a.8.8 0 0 1 0-1.61h10.49a.8.8 0 0 1 0 1.61h-8.33a.2.2 0 0 0 0 .42h.85a2.24 2.24 0 0 0 4.46 0h3.02a1.22 1.22 0 0 0 0-2.45ZM14.8 8.75a.83.83 0 0 1 .81.66 7.16 7.16 0 0 0-1.62 0 .83.83 0 0 1 .81-.66Zm0 13.23a1.82 1.82 0 0 1-1.8-1.62h3.61a1.82 1.82 0 0 1-1.8 1.62Zm0 0",
    "data-name": "Path 1093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84 11.82a.2.2 0 0 0 .21-.21 2.21 2.21 0 0 1 .82-1.89.2.2 0 0 0-.22-.35 2.62 2.62 0 0 0-1.02 2.24.2.2 0 0 0 .21.2Zm0 0",
    "data-name": "Path 1097"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBell2);
export default __webpack_public_path__ + "static/media/notification-bell2.bbaa36d709a78a94d0cbc1806656e862.svg";
export { ForwardRef as ReactComponent };